import type { ScheduleTRPCInput } from '@risksmart-app/trpc/src/types';
import { mapScheduleToTRPC } from '@risksmart-app/trpc/src/types';
import type {
  UpdateChildDocumentInput,
  UpdateDocumentMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  namedOperations,
  UpdateDocumentDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateDocumentTRPCInput = Omit<UpdateChildDocumentInput, 'schedule'> &
  ScheduleTRPCInput;

export const useUpdateDocument = createMutationHook({
  name: 'updateDocument',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.document.update.mutationOptions({ onSuccess }),
  mapInput: ({
    schedule,
    ...rest
  }: UpdateChildDocumentInput): UpdateDocumentTRPCInput => ({
    ...rest,
    ...mapScheduleToTRPC(schedule),
  }),
  invalidate: (trpc) => [
    trpc.frontend.document.register.queryKey(),
    trpc.frontend.document.documentById.queryKey(),
    trpc.frontend.document.list.queryKey(),
  ],
  mapResponse: (result: { Id: string }): UpdateDocumentMutation => ({
    updateChildDocument: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: UpdateDocumentDocument,
  graphqlVariables: (input: UpdateChildDocumentInput) => ({ object: input }),
  evictFields: ['document'],
  refetchQueries: [namedOperations.Query.getDocumentById],
});
